/*
本文の短い「…」(かぎ括弧を含めて 12 字以内) を折り返さない 1 つの塊 (span.md-nowrap.lgm-nobr) にする。
スマホの幅では「数値 / B を出す」「カウンタ < / 12」のように、短い語の途中で折れていた。
iPhone の Safari は word-break auto-phrase に対応しないので、字の側で塊にする。長い引用 (13 字以上) は今までどおり折る。
包むのは地の字の中で「と」が同じ字のノードに入っているものだけ。コード、整形済み、リンク、見出し、表の中は触らない。字は 1 字も変えない。
md-nowrap も付けるのは、rehypeKeepNumberUnits と rehypePhraseBreaks が塊の中を触らない目印にしているため。見た目 (折り返さない) は lg-prose.css と luagate-materials.css が付ける
*/

type HastNode = {
  type: string;
  tagName?: string;
  value?: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
};

const SKIP = new Set([
  "pre", "code", "kbd", "samp", "svg", "style", "script", "textarea", "math",
  "select", "option", "optgroup", "datalist", "title", "iframe", "noscript", "template",
  "a", "h1", "h2", "h3", "h4", "h5", "h6", "table", "button",
]);
const SKIP_CLASSES = ["md-nowrap", "md-tail", "lgm-nobr"];
export const QUOTE_MAX_LENGTH = 12;
// 「と」のあいだに「 や 」を含まない、12 字以内の対
const QUOTE = new RegExp(`「[^「」]{1,${QUOTE_MAX_LENGTH - 2}}」`, "g");

function classes(node: HastNode): string[] {
  const cls = node.properties?.className;
  return (Array.isArray(cls) ? cls : typeof cls === "string" ? cls.split(/\s+/) : []).map(String);
}

function splitText(value: string): HastNode[] | null {
  const matches = [...value.matchAll(QUOTE)];
  if (matches.length === 0) return null;
  const out: HastNode[] = [];
  let from = 0;
  for (const m of matches) {
    const start = m.index ?? 0;
    if (start > from) out.push({ type: "text", value: value.slice(from, start) });
    out.push({
      type: "element",
      tagName: "span",
      properties: { className: ["md-nowrap", "lgm-nobr"] },
      children: [{ type: "text", value: m[0] }],
    });
    from = start + m[0].length;
  }
  if (from < value.length) out.push({ type: "text", value: value.slice(from) });
  return out;
}

function walk(node: HastNode): void {
  if (!node.children) return;
  const next: HastNode[] = [];
  let changed = false;
  for (const child of node.children) {
    if (child.type === "text") {
      const parts = splitText(child.value ?? "");
      if (parts) {
        next.push(...parts);
        changed = true;
        continue;
      }
    } else if (child.type === "element" && !SKIP.has(child.tagName ?? "") && !classes(child).some((c) => SKIP_CLASSES.includes(c))) {
      walk(child);
    }
    next.push(child);
  }
  if (changed) node.children = next;
}

export function rehypeKeepQuotes() {
  return (tree: HastNode) => {
    walk(tree);
  };
}
